import { api } from '@/helpers/api'
import { commonUtils } from '@/helpers/commonUtils'
import { cloneDeep } from 'lodash'
export class PayHelper {
  private checkTimer: NodeJS.Timeout | null = null
  private order: ServerData.CreateOrderData | null = null
  private sessionId: string = ''

  checkPayStatus = async (sessionId: string, onPaySuccess?: (status: string) => void) => {
    if (sessionId !== this.sessionId || !this.order) {
      return
    }

    this.stopCheckPayStatus()

    const { data } = await api.order.checkOrderStatus(this.order.outTradeNo).catch((err) => {
      return { data: { status: 'failed' } }
    })

    if (data.status !== 'completed') {
      this.checkTimer = setTimeout(() => this.checkPayStatus(sessionId, onPaySuccess), 1000)
      return
    }

    onPaySuccess?.(data.status)
  }

  stopCheckPayStatus = () => {
    if (this.checkTimer) {
      clearTimeout(this.checkTimer)
      this.checkTimer = null
    }
  }

  closePay = () => {
    this.order = null
    this.sessionId = ''
    this.stopCheckPayStatus()
  }

  createPayQrCode = async (
    par: PostData.CreateOrderData & {
      onCreateOrder: (data: ServerData.CreateOrderData) => void
      onPaySuccess?: (status: string) => void
    }
  ) => {
    const sessionId = commonUtils.genId()
    this.sessionId = sessionId

    const { data } = await api.order.createOrder({
      planId: par.planId,
      materialId: par.materialId,
      chargeChannel: par.chargeChannel,
    })

    if (this.sessionId !== sessionId) {
      return
    }

    this.order = data
    par.onCreateOrder(cloneDeep(data))
    this.checkPayStatus(sessionId, par.onPaySuccess)
  }
}
